import api from './client';

export const getUsers             = () => api.get('/users');
export const createUser           = (data) => api.post('/users', data);
export const updateUser           = (id, data) => api.put(`/users/${id}`, data);
export const deleteUser           = (id) => api.delete(`/users/${id}`);
export const uploadUserAvatar     = (id, formData) => api.post(`/users/${id}/profile-image`, formData);
export const getMe                = () => api.get('/users/me');
export const updateMyProfile      = (data) => api.put('/users/me/profile', data);
export const getEmployeeOverview  = () => api.get('/users/overview');
